import React, { useState } from 'react';
import { buildingData, researchData, shipData } from '../data';

// Target picker for Auto Plan (see plan.md — Auto Plan integration). Scoped
// to a single planet (the one the user opened it from) — planGreedy only
// supports single-planet targets in v1, so there's no planet-picker here.
const AutoPlanModal = ({ initialState, planetId, onStart, onClose }) => {
  const planet = initialState.planets[planetId];
  const [targetBuildings, setTargetBuildings] = useState({ ...planet.buildings });
  const [targetShips, setTargetShips] = useState({ ...planet.ships });
  const [targetResearch, setTargetResearch] = useState({ ...initialState.research });

  const handleBuildingChange = (e) => {
    const { name, value } = e.target;
    setTargetBuildings((prev) => ({ ...prev, [name]: parseInt(value) || 0 }));
  };

  const handleShipChange = (e) => {
    const { name, value } = e.target;
    setTargetShips((prev) => ({ ...prev, [name]: parseInt(value) || 0 }));
  };

  const handleResearchChange = (e) => {
    const { name, value } = e.target;
    setTargetResearch((prev) => ({ ...prev, [name]: parseInt(value) || 0 }));
  };

  const handleStart = () => {
    onStart(planetId, {
      research: targetResearch,
      planets: { [planetId]: { buildings: targetBuildings, ships: targetShips } },
    });
  };

  return (
    <div className="fixed inset-0 bg-gray-900 z-50 bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-1/3 max-h-[70vh] overflow-y-auto text-gray-900">
        <h2 className="text-lg font-bold mb-4 text-gray-900">Auto Plan: {planet.name}</h2>
        <p className="text-sm text-gray-600 mb-4">
          Set target levels/counts below. Auto Plan generates a fresh build order for this planet from its
          starting settings — any manual steps already queued for it will be replaced if you accept the result.
        </p>

        <div className="mb-4">
          <h3 className="font-semibold mb-2 text-left text-gray-900">Buildings</h3>
          <div className="grid grid-cols-1 gap-4 pl-4">
            {Object.keys(targetBuildings).map((building) => (
              <div key={building} className="grid grid-cols-2 gap-4">
                <label className="text-left text-gray-900">{buildingData[building].name}</label>
                <input
                  type="number"
                  name={building}
                  min={planet.buildings[building]}
                  value={targetBuildings[building]}
                  onChange={handleBuildingChange}
                  className="p-1 border rounded w-full text-gray-900"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="mb-4">
          <h3 className="font-semibold mb-2 text-left text-gray-900">Ships</h3>
          <div className="grid grid-cols-1 gap-4 pl-4">
            {Object.keys(targetShips).map((ship) => (
              <div key={ship} className="grid grid-cols-2 gap-4">
                <label className="text-left text-gray-900">{shipData[ship].name}</label>
                <input
                  type="number"
                  name={ship}
                  min={planet.ships[ship]}
                  value={targetShips[ship]}
                  onChange={handleShipChange}
                  className="p-1 border rounded w-full text-gray-900"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="mb-4">
          <h3 className="font-semibold mb-2 text-left text-gray-900">Research</h3>
          <div className="grid grid-cols-1 gap-4 pl-4">
            {Object.keys(targetResearch).map((tech) => (
              <div key={tech} className="grid grid-cols-2 gap-4">
                <label className="text-left text-gray-900">{researchData[tech].name}</label>
                <input
                  type="number"
                  name={tech}
                  min={initialState.research[tech]}
                  value={targetResearch[tech]}
                  onChange={handleResearchChange}
                  className="p-1 border rounded w-full text-gray-900"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-end space-x-2">
          <button onClick={handleStart} className="bg-green-600 text-white py-1 px-4 rounded">
            Start Auto Plan
          </button>
          <button onClick={onClose} className="bg-gray-300 text-gray-900 py-1 px-4 rounded">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AutoPlanModal;
